import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './KeyUseCases.css';

const sectionVariants = {
  hidden: { opacity: 0, y: 80, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
      when: 'beforeChildren',
      staggerChildren: 0.08,
    },
  },
};

const childVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] } },
};

const KeyUseCases = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    document.documentElement.getAttribute('data-theme') === 'dark'
  );
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' });

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const newTheme = document.documentElement.getAttribute('data-theme');
      setIsDarkMode(newTheme === 'dark');
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <motion.section
      className="key-use-cases-section"
      ref={ref}
      variants={sectionVariants}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
    >
      <div className="key-use-cases-content">
        <motion.div className="key-use-cases-right" variants={childVariants}>
          <img 
            src="/images/Keyuse.png" 
            alt="Genix AI Assistant" 
            className="main-key-use-image"
          />
        </motion.div>
        <motion.div className="key-use-cases-left" variants={childVariants}>
          <motion.div className="use-case-cards-grid" variants={childVariants}>
            <motion.div
              className="use-case-card"
              style={{
                border: 'none',
                boxShadow: 'none',
                backgroundColor: isDarkMode ? 'rgb(45, 55, 72)' : '#f8fafc',
                flexDirection: 'column',
              }}
              variants={childVariants}
            >
              <p className="use-case-text" style={{ fontSize: '30px' }}>Key Use Cases</p>
              <span className="use-case-subtext">See how Genix AI fits into real-world care.</span>
            </motion.div>

            <motion.div className="use-case-card" style={{ flexDirection: 'column' }} variants={childVariants}>
              <img src="/images/Transcription1.png" alt="Doctors & Clinics" className="use-case-icon" />
              <p className="use-case-text">Doctors & Clinics</p>
              <span className="use-case-subtext">Save time with hands-free, AI-generated notes and real-time multilingual support.</span>
            </motion.div>

            <motion.div className="use-case-card" variants={childVariants}>
              <img src="/images/Telehealth.png" alt="Telehealth Appointments" className="use-case-icon" />
              <p className="use-case-text">Telehealth Appointments</p>
            </motion.div>

            <motion.div className="use-case-card" variants={childVariants}>
              <img src="/images/HospitalNhs.png" alt="Hospitals & NHS Trusts" className="use-case-icon" />
              <p className="use-case-text">Hospitals & NHS Trusts</p>
            </motion.div>

            <motion.div className="use-case-card" variants={childVariants}>
              <img src="/images/Elderly.png" alt="Elderly & Dementia Care" className="use-case-icon" />
              <p className="use-case-text">Elderly & Dementia Care</p>
            </motion.div>

            <motion.div className="use-case-card" variants={childVariants}>
              <img src="/images/NGO.png" alt="NGOs & Mobile Clinics" className="use-case-icon" />
              <p className="use-case-text">NGOs & Mobile Clinics</p>
            </motion.div>

          </motion.div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default KeyUseCases;
